// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__16aBz","checkboxCol":"Table_checkboxCol__td6WY","emailCol":"Table_emailCol__2rko2","actionCol":"Table_actionCol__1hzjb"};